<template>
	<div class="box">
		<div class="header flex flex-align-center mb-8">
			<span style="width: 20px; height: 20px;background:#FE3363;border-radius:50%"></span>
			<p class="fz-12 ml-4" style="color: #3d3d3d">小程序名称</p>
		</div>
		<div class="title mb-8" style="color: #1d2129">
			{{ product_name }}
		</div>
		<div class="goods-img">
			<el-image fit="cover" :src="product_pic" style="height: 181px; width: 100%" alt="" />
			<div class="info flex flex-just-between flex-align-center" v-if="isShow">
				<el-image :src="require('./img/goods-img-background.png')" style="width: 100%;"></el-image>
				<div class="info-content">
					<div class="show-data">
						<div class="show-data-item">
							<div class="item-value">{{ item.commission_rate }}%</div>
							<div>佣金率</div>
						</div>
						<div class="show-data-item" v-if="item.commission_rate_during_the && item.commission_rate_during_the!= 0">
							<div class="item-value">{{ item.commission_rate_during_the }}%</div>
							<div>投放期佣金率</div>
						</div>
						<div class="show-data-item">
							<div class="item-value">¥{{ item.live_price }}</div>
							<div>直播价</div>
						</div>
					</div>
					<div class="look-text">立即查看 <i class="el-icon-caret-right"></i></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/mixins';
import { getMiniAppF } from '@/api/common';
export default {
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		nowType: {
			type: Number,
			default: 1,
		},
		customTitle: {
			type: String,
			default: '',
		},
		default_img: {
			type: String,
			default: '',
		},
	},
	mixins: [mixin],
	computed: {
		product_name({ item, nowType, customTitle }) {
			let obj = {
				0: item.product_name,
				1: customTitle || '输入的小程序卡片标题将会在此处展示...',
				2: item.product_name || '小程序卡片标题将会在此处展示...',
				3: customTitle,
			};
			return obj[nowType];
		},
		product_pic({ item, nowType, default_img }) {
			let img = default_img || require('./img/share-default.png');
			let obj = {
				0: item.product_pic,
				1: img,
				2: item.product_pic || require('./img/share-default.png'),
				3: img,
			};
			return obj[nowType];
		},
		isShow({ nowType, item }) {
			return nowType === 0 || (nowType === 2 && item.product_name);
		},
	},
	data() {
		return {
			minAppIcon: '',
			minAppName: '',
		};
	},
	created() {
		this.initIMG();
	},
	methods: {
		async initIMG() {
			try {
				const { min_app_icon, min_app_name } = await getMiniAppF();
				this.minAppIcon = min_app_icon;
				this.minAppName = min_app_name;
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>
<style lang="less" scoped>
.box {
	width: 226px;
	.header {
	}
	.title {
		height: 42px;
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2; /* 这里是超出几行省略 */
		overflow: hidden;
	}
	.goods-img {
		height: 181px;
		position: relative;
		img {
			width: 100%;
			height: 100%;
		}
		.info {
			position: absolute;
			bottom: 0px;
			height: 67px;
			border-radius: 6px;
			.info-content {
				position: absolute;
				width: 100%;
				left: 0px;
				top: 4px;
				color: #fff;
				.show-data{
					display: flex;
					align-items: flex-start;
					justify-content: space-evenly;
					font-size: 8px;
					margin-bottom: 12px;
					height: 30px;
					width: 100%;
					color: #A30037;
					.show-data-item{
						text-align: center;
						.item-value{
							font-size: 12px;
							font-weight: bold;
							color: #FF0959;
						}
					}

				}
				.look-text{
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 12px;
					font-weight: bold;
					i{
						border-radius: 2px;
					}
				}
			}
		}
	}
}
</style>
